var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLendOldHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: "current",
      height: "current",
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:current;stroke:current;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M495.984,264.498l15.891,0.102l-0.078-0.102H512L370.625,88.557H143.918h-3.773l-13.016,16.195l-78.847,98.39 L0,263.233h0.129L0,263.393h45.008v121.946H15.875v38.105h480.25v-38.105h-25.442v-120.84H495.984z M56.121,240.53l-7.699-0.098 l68.958-86.058l22.874-28.462l84.469,136.149v117.562h-54.629v-102.89h-53.011v102.89H68.824V240.53H56.121z M446.871,264.498 v115.125H248.539V264.498H446.871z",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.203,
    y: 291.814,
    className: "st0",
    width: 56.558,
    height: 44.778,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.543,
    y: 291.814,
    className: "st0",
    width: 56.558,
    height: 44.778,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLendOldHouse);
export default __webpack_public_path__ + "static/media/LendOldHouse.60eb62e47a22344a2853446e88f9a255.svg";
export { ForwardRef as ReactComponent };